app.controller("StudentDocsCommentModalController", [
    "$scope", "$q", "StSubject", "comments", "$uibModalInstance",
    function ($scope, $q, StSubject, comments, $uibModalInstance) {
        $scope.comments = comments;

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
